/**
 * Modal login button component.
 */
import Container from '@components/atoms/container/anonymousModalLogin';
import Button from '@components/atoms/buttons/modalButton';
import Props from '@shared/types/props/pressable';
import Text from '@components/atoms/text/anonymousModalAccount';
import useButton from './useButton';

/**
 * Displays the modal button with the given text and action.
 */
export default function ModalButton(parentProps: Props & { tip?: string }) {
  const { callbacks, props, buttonText, buttonTip } = useButton(parentProps);
  return (
    <Container>
      <Text>{buttonTip}</Text>
      <Button {...props} {...callbacks}>
        {buttonText}
      </Button>
    </Container>
  );
}
